import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import MovieIcon from '@mui/icons-material/Movie';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShieldIcon from '@mui/icons-material/Shield';
import BuildIcon from '@mui/icons-material/Build';
import SportsIcon from '@mui/icons-material/Sports';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SendIcon from '@mui/icons-material/Send';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import FlagIcon from '@mui/icons-material/Flag';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CachedIcon from '@mui/icons-material/Cached';

import {
    PossessionsIcon, GloveIcon, ShieldIcon as PhaseShieldIcon, TrendUpIcon, DoubleUpIcon, ShieldPersonIcon,
    TransitionRingIcon, BoltIcon, RunnerIcon, CornerFlagIcon, WallIcon, ThrowInIcon,
    GoalIcon, TargetIcon, OffsideFlagIcon, HandIcon, BlockedIcon, BroomIcon, OneVOneIcon, KickOffIcon
} from './tagIcons';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import GavelIcon from '@mui/icons-material/Gavel';
import PanToolIcon from '@mui/icons-material/PanTool';
import BlockIcon from '@mui/icons-material/Block';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

const tagIcons = {
    'Started from stolen or unsuccessful 1v1 and become chance for the opponent': OneVOneIcon,
    'Started from successful 1v1 and become chance': OneVOneIcon,
    'Clearance': BroomIcon,
    'Defending Throw Ins': ThrowInIcon,
    'Defending Free Kicks': WallIcon,
    'Defending Corners': CornerFlagIcon,
    'Attacking Throw Ins': ThrowInIcon,
    'Attacking Free Kicks': WallIcon,
    'Opponent Goals': GoalIcon,
    'Opponent Chances': TargetIcon,
    'Opponent Offsides': OffsideFlagIcon,
    'Opponent Saved': HandIcon,
    'Opponent Blocked': BlockedIcon,
    'Opponent Clearance': BroomIcon,
    'Kick-Offs': KickOffIcon,
    'Attacking Corners': CornerFlagIcon,
    'Counter Defense after 1v1': RunnerIcon,
    'Counter Defense after pass interception': BoltIcon,
    'All Transitions from Attack to Defense': TransitionRingIcon,
    'Counter Attack after 1v1': RunnerIcon,
    'Counter Attack after pass interception': BoltIcon,
    'All Transitions from Defense to Attack': TransitionRingIcon,
    'Defense': ShieldPersonIcon,
    'High Press': DoubleUpIcon,
    'Opponent Gk Press': GloveIcon,
    'Attack': TrendUpIcon,
    'Build Up Under Pressure': PhaseShieldIcon,
    'Gk Distribution': GloveIcon,
    'All Attacking Possessions': PossessionsIcon,
    'Game Highlight': MovieIcon,
    'Clean Game': PlayCircleIcon,
    'All Offensive Possessions': PossessionsIcon,
    'All Defensive Possessions': PhaseShieldIcon,
    'Build Up Opponent Half': TrendUpIcon,
    'Build Up Own Half': PhaseShieldIcon,
    'Build Up Goalkeeper': SportsIcon,
    'Started From Goalkeeper': GloveIcon,
    'Counter-Attacks': FlashOnIcon,
    'Started From Interception': SwapHorizIcon,
    'Started From Tackle': FitnessCenterIcon,
    'Started From Throw In': ThrowInIcon,
    'Started From Free Kicks': WallIcon,
    'Started From Corners': CornerFlagIcon,
    'Possessions With Goals': GoalIcon,
    'Possessions That Draw Penalty': ReportProblemIcon,
    'Goals': GoalIcon,
    'Chances': TargetIcon,
    'Free Kicks': SportsSoccerIcon,
    'Corners': FlagIcon,
    'Crosses': CallMadeIcon,
    'Draw Fouls': ReportProblemIcon,
    'Turnovers': CachedIcon,
    'Offsides': OffsideFlagIcon,
    'Penalties Gained': GavelIcon,
    'Saved': HandIcon,
    'Blocked': BlockedIcon,
    'Clearance': CleaningServicesIcon
};

const tagColors = {
    'Started from stolen or unsuccessful 1v1 and become chance for the opponent': '#dc2626',
    'Started from successful 1v1 and become chance': '#16a34a',
    'Clearance': '#3b82f6',
    'Possessions With Goals': '#d97706',
    'Defending Throw Ins': '#dc2626',
    'Defending Free Kicks': '#dc2626',
    'Defending Corners': '#dc2626',
    'Attacking Throw Ins': '#16a34a',
    'Started From Free Kicks': '#16a34a',
    'Attacking Free Kicks': '#16a34a',
    'Started From Corners': '#16a34a',
    'Opponent Goals': '#dc2626',
    'Opponent Chances': '#dc2626',
    'Opponent Offsides': '#dc2626',
    'Opponent Saved': '#dc2626',
    'Opponent Blocked': '#dc2626',
    'Opponent Clearance': '#dc2626',
    'Kick-Offs': '#16a34a',
    'Attacking Corners': '#16a34a',
    'Counter Defense after 1v1': '#dc2626',
    'Counter Defense after pass interception': '#dc2626',
    'All Transitions from Attack to Defense': '#dc2626',
    'Counter Attack after 1v1': '#16a34a',
    'Counter Attack after pass interception': '#16a34a',
    'All Transitions from Defense to Attack': '#16a34a',
    'Defense': '#dc2626',
    'High Press': '#dc2626',
    'Opponent Gk Press': '#dc2626',
    'Attack': '#16a34a',
    'Build Up Under Pressure': '#1e40af',
    'Gk Distribution': '#16a34a',
    'All Attacking Possessions': '#16a34a',
    'Game Highlight': '#6366f1',
    'Clean Game': '#8b5cf6',
    'All Offensive Possessions': '#16a34a',
    'All Defensive Possessions': '#dc2626',
    'Build Up Opponent Half': '#16a34a',
    'Build Up Own Half': '#1e40af',
    'Build Up Goalkeeper': '#14b8a6',
    'Started From Goalkeeper': '#16a34a',
    'Counter-Attacks': '#ef4444',
    'Started From Interception': '#ec4899',
    'Started From Tackle': '#f97316',
    'Started From Throw In': '#16a34a',
    'Goals': '#d97706',
    'Chances': '#2563eb',
    'Free Kicks': '#0ea5e9',
    'Corners': '#f43f5e',
    'Crosses': '#6366f1',
    'Draw Fouls': '#f97316',
    'Turnovers': '#64748b',
    'Offsides': '#6b7280',
    'Penalties Gained': '#dc2626',
    'Saved': '#16a34a',
    'Blocked': '#1f2937',
    'Clearance': '#7c3aed'
};

const GameTagCard = ({ isSelected, tagname, button, onShow, t, isLoading }) => {
    const Icon = tagIcons[tagname] || SportsSoccerIcon;
    const color = tagColors[tagname] || '#6366f1';

    return (
        <Box
            onClick={onShow(button || { label: tagname, tag: tagname })}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 8px',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                backgroundColor: isSelected ? color : '#f9fafb',
                border: `2px solid ${isSelected ? color : `${color}4D`}`,
                boxShadow: isSelected ? `0 2px 8px ${color}35` : `0 1px 2px rgba(0,0,0,0.04)`,
                '&:hover': {
                    borderColor: color,
                    backgroundColor: isSelected ? color : `${color}08`,
                    transform: 'translateY(-1px)'
                },
                minHeight: '80px',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: isSelected ? 'rgba(255,255,255,0.2)' : `${color}12`,
                    marginBottom: '5px'
                }}
            >
                {isLoading ? (
                    <CircularProgress size={22} sx={{ color: isSelected ? '#ffffff' : color }} />
                ) : (
                    <Icon sx={{
                        fontSize: 27,
                        color: isSelected ? '#ffffff' : color
                    }} />
                )}
            </Box>
            <Typography
                sx={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: isSelected ? '#ffffff' : '#4b5563',
                    textAlign: 'center',
                    lineHeight: 1.15,
                    maxWidth: '100%'
                }}
            >
                {t(tagname)}
            </Typography>
        </Box>
    );
};

export default GameTagCard;
